module.exports = __webpack_public_path__ + "static/media/MobileNet.2e1ac509.png";